import React from 'react'
import { Link } from 'react-router-dom'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import './product-specification.css'

const ProductSpecification = (props) => {
  return (
    <div className="product-specification-container1">
      <Helmet>
        <title>Product-Specification - Heidric Industrial Gas Trading</title>
        <meta
          property="og:title"
          content="Product-Specification - Heidric Industrial Gas Trading"
        />
        <meta property="og:type" content="website" />
        <meta
          name="twitter:title"
          content="Product-Specification - Heidric Industrial Gas Trading"
        />
        <link
          rel="canonical"
          href="https://heidric-industrial-gas-trading-5gvzeu.teleporthq.site/product-specification"
        />
        <meta
          property="og:url"
          content="https://heidric-industrial-gas-trading-5gvzeu.teleporthq.site/product-specification"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html:
              '{"@context":"https://schema.org","@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Home","item":"https://heidric-industrial-gas-trading-5gvzeu.teleporthq.site"},{"@type":"ListItem","position":2,"name":"Product-Specification","item":"https://heidric-industrial-gas-trading-5gvzeu.teleporthq.site/product-specification"}]}',
          }}
        />
      </Helmet>
      <header
        data-thq="thq-navbar"
        className="product-specification-thq-navbar-elm"
      >
        <div className="product-specification-thq-left-elm1">
          <img
            loading="eager"
            decoding="async"
            alt="image"
            src="/Branding/heidric%20icon%20logo-200h.png"
            fetchpriority="high"
            className="product-specification-thq-logo-elm"
          />
          <nav className="product-specification-thq-links-elm1">
            <a href="#Home" className="product-specification-thq-link-elm10">
              Home
            </a>
            <a
              href="#About Us"
              className="product-specification-thq-link-elm11"
            >
              About
            </a>
            <a href="#Why Us" className="product-specification-thq-link-elm12">
              Why Us
            </a>
            <a
              href="#2 Featured Product"
              className="product-specification-thq-link-elm13"
            >
              Featured Product
            </a>
            <a href="#Contact" className="product-specification-thq-link-elm14">
              Contact
            </a>
          </nav>
        </div>
        <div
          data-thq="thq-navbar-btn-group"
          className="product-specification-thq-right-elm1"
        ></div>
        <div
          data-thq="thq-burger-menu"
          className="product-specification-thq-burger-menu-elm"
        >
          <svg viewBox="0 0 1024 1024" className="product-specification-icon10">
            <path d="M128 554.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM128 298.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM128 810.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667z"></path>
          </svg>
        </div>
        <div
          data-thq="thq-mobile-menu"
          className="product-specification-thq-mobile-menu-elm"
        >
          <div
            data-thq="thq-mobile-menu-nav"
            data-role="Nav"
            className="product-specification-thq-nav-elm1"
          >
            <div className="product-specification-thq-container-elm">
              <img
                loading="eager"
                decoding="async"
                alt="image"
                src="/Branding/heidric%20icon%20logo-200h.png"
                className="product-specification-image1"
              />
              <div
                data-thq="thq-close-menu"
                className="product-specification-thq-menu-close-elm"
              >
                <svg
                  viewBox="0 0 1024 1024"
                  className="product-specification-icon12"
                >
                  <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
                </svg>
              </div>
            </div>
            <nav
              data-thq="thq-mobile-menu-nav-links"
              data-role="Nav"
              className="product-specification-thq-nav-elm2"
            >
              <a href="#Home" className="product-specification-thq-link-elm15">
                Home
              </a>
              <a
                href="#About Us"
                className="product-specification-thq-link-elm16"
              >
                About
              </a>
              <a
                href="#Why Us"
                className="product-specification-thq-link-elm17"
              >
                Why Us
              </a>
              <a
                href="#2 Featured Product"
                className="product-specification-thq-link-elm18"
              >
                Featured Product
              </a>
            </nav>
          </div>
        </div>
      </header>
      <div id="tq-main" className="product-specification-container2">
        <Link to="/" className="product-specification-navlink">
          <div className="product-specification-thq-overview-card-elm1 overview-card">
            <span className="product-specification-thq-overview-card-title-elm1 overview-card-title">
              <span>Back</span>
              <br></br>
            </span>
            <img
              loading="eager"
              decoding="async"
              alt="image"
              src="/Icons/back-svgrepo-com1.svg"
              className="product-specification-image2"
            />
          </div>
        </Link>
      </div>
      <section
        id="specifications"
        className="product-specification-thq-spec-table-section-elm spec-table-section"
      >
        <div className="spec-table-container">
          <h2 className="spec-table-title">Product Specifications</h2>
          <div className="spec-table-wrapper">
            <table className="spec-table">
              <thead>
                <tr>
                  <th>
                    <span>Property</span>
                  </th>
                  <th>
                    <span>Refrigeration Grade Ammonia</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <span>Chemical name</span>
                  </td>
                  <td>
                    <span>Anhydrous Ammonia</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span>Chemical formula</span>
                  </td>
                  <td className="accent-value">
                    <span>NH₃</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span>Refrigerant designation</span>
                  </td>
                  <td className="accent-value">
                    <span>R-717</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span>Physical appearance</span>
                  </td>
                  <td>
                    <span>Colorless gas/liquid under pressure</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span>Odor</span>
                  </td>
                  <td>
                    <span>Strong, pungent</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span>Normal boiling point</span>
                  </td>
                  <td>
                    <span>Approximately -33.3°C</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span>Ozone Depletion Potential</span>
                  </td>
                  <td className="accent-value">
                    <span>0</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span>Global Warming Potential</span>
                  </td>
                  <td>
                    <span>
                      Very low / commonly treated as 0 in refrigerant
                      comparisons
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span>Typical refrigeration-grade purity</span>
                  </td>
                  <td className="accent-value">
                    <span>≥99.98% NH₃</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
      <section
        id="quick-specs"
        className="overview-grid product-specification-thq-overview-grid-elm"
      >
        <div className="overview-container">
          <div className="overview-cards">
            <div className="overview-card">
              <div className="overview-card-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M14 2v6a2 2 0 0 0 .245.96l5.51 10.08A2 2 0 0 1 18 22H6a2 2 0 0 1-1.755-2.96l5.51-10.08A2 2 0 0 0 10 8V2M6.453 15h11.094M8.5 2h7"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <span className="overview-card-title">Chemical Formula</span>
              <span className="overview-card-value">NH₃</span>
            </div>
            <div className="overview-card">
              <div className="overview-card-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="m10 20l-1.25-2.5L6 18m4-14L8.75 6.5L6 6m4.585 9H10m-8-3h6.5L10 9m10 5.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0z"></path>
                    <path d="m4 10l1.5 2L4 14m3 7l3-6l-1.5-3M7 3l3 6h2"></path>
                  </g>
                </svg>
              </div>
              <span className="overview-card-title">
                Refrigerant Designation
              </span>
              <span className="overview-card-value">R-717</span>
            </div>
            <div className="overview-card">
              <div className="overview-card-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <span className="overview-card-title">Purity</span>
              <span className="overview-card-value">≥99.98% NH₃</span>
            </div>
            <div className="overview-card">
              <div className="overview-card-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="m10 20l-1.25-2.5L6 18m4-14L8.75 6.5L6 6m8 14l1.25-2.5L18 18M14 4l1.25 2.5L18 6"></path>
                    <path d="m17 21l-3-6h-4m7-12l-3 6l1.5 3M2 12h6.5L10 9m10 1l-1.5 2l1.5 2"></path>
                    <path d="M22 12h-6.5L14 15M4 10l1.5 2L4 14m3 7l3-6l-1.5-3M7 3l3 6h4"></path>
                  </g>
                </svg>
              </div>
              <span className="overview-card-title">Boiling Point</span>
              <span className="overview-card-value">Approx. -33.3°C</span>
            </div>
          </div>
        </div>
      </section>
      <section
        id="benefits"
        className="benefits-grid product-specification-thq-benefits-grid-elm"
      >
        <div className="benefits-container">
          <h2 className="benefits-title">
            Benefits of Using Refrigeration Grade Ammonia
          </h2>
          <div className="benefits-cards">
            <div className="benefit-card">
              <div className="benefit-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M15.914 4a1.5 1.5 0 0 0-2.474-1.561l-9 9A1.5 1.5 0 0 0 5.5 14h4.002a.5.5 0 0 1 .471.666L8.086 20a1.5 1.5 0 0 0 2.475 1.56l9-9A1.5 1.5 0 0 0 18.5 10h-3.997a.5.5 0 0 1-.472-.667z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="benefit-card-title">
                Excellent Refrigeration Performance
              </h3>
              <p className="benefit-card-desc">
                Excellent refrigeration performance for demanding industrial
                cooling.
              </p>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M11 20a10 10 0 0 0 10-10a25.9 25.9 0 0 0-1.04-7.281a1 1 0 0 0-1.755-.325C15.833 5.5 13 5.5 9.8 6.1A7 7 0 0 0 11 20"></path>
                    <path d="M2 21a5 5 0 0 1 2.911-4.544C7.613 15.212 8.351 15.24 11 13"></path>
                  </g>
                </svg>
              </div>
              <h3 className="benefit-card-title">Suitable for Large Systems</h3>
              <p className="benefit-card-desc">
                Ideal for large-scale industrial systems and warehouses.
              </p>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M15.914 4a1.5 1.5 0 0 0-2.474-1.561l-9 9A1.5 1.5 0 0 0 5.5 14h4.002a.5.5 0 0 1 .471.666L8.086 20a1.5 1.5 0 0 0 2.475 1.56l9-9A1.5 1.5 0 0 0 18.5 10h-3.997a.5.5 0 0 1-.472-.667z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="benefit-card-title">Energy Efficiency</h3>
              <p className="benefit-card-desc">
                Lower electricity consumption through superior thermal
                properties.
              </p>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M11 20a10 10 0 0 0 10-10a25.9 25.9 0 0 0-1.04-7.281a1 1 0 0 0-1.755-.325C15.833 5.5 13 5.5 9.8 6.1A7 7 0 0 0 11 20"></path>
                    <path d="M2 21a5 5 0 0 1 2.911-4.544C7.613 15.212 8.351 15.24 11 13"></path>
                  </g>
                </svg>
              </div>
              <h3 className="benefit-card-title">Environment Friendly</h3>
              <p className="benefit-card-desc">
                Zero ozone depletion and minimal global warming impact.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section id="safety" className="safety-notice">
        <div className="safety-container">
          <div className="safety-rail product-specification-thq-safety-rail-elm">
            <div className="dot-grid">
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="accent dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
            </div>
          </div>
          <div className="safety-content">
            <h2 className="safety-title product-specification-thq-safety-title-elm">
              Safety Information
            </h2>
            <p className="safety-description product-specification-thq-safety-description-elm">
              Ammonia is a hazardous chemical and should be handled according to
              appropriate safety procedures and requirements.
            </p>
            <div className="hazard-badges">
              <div className="hazard-badge">
                <span>Corrosive</span>
              </div>
              <div className="hazard-badge">
                <span>Flammable</span>
              </div>
              <div className="hazard-badge">
                <span>Toxic</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="product-specification-container3">
        <div className="product-specification-container4">
          <Script
            html={`<style>
body {
  font-family: 'Inter', sans-serif;
  color: var(--color-on-surface);
  background: var(--color-surface);
  line-height: 1.6;
}
h1, h2, h3 {
  font-weight: 800;
  color: var(--color-on-surface);
  margin: 0;
}
</style>`}
          ></Script>
        </div>
      </div>
      <div className="product-specification-thq-footer-elm">
        <div className="product-specification-thq-left-elm2">
          <div className="product-specification-thq-brand-elm">
            <img
              loading="lazy"
              decoding="async"
              alt="image"
              src="/Branding/heidric%20icon%20logo-200h.png"
              className="product-specification-image3"
            />
          </div>
          <div className="product-specification-thq-legal-elm1">
            <span className="product-specification-thq-copyright-elm1">
              © 2022 Heidric Industrial Gas. All Rights Reserved.
            </span>
          </div>
        </div>
        <div className="product-specification-thq-right-elm2">
          <div className="product-specification-thq-list-elm1">
            <span className="product-specification-thq-header-elm1">Menu</span>
            <div className="product-specification-thq-links-elm2">
              <a href="#Home" className="product-specification-thq-link-elm19">
                Home
              </a>
              <a
                href="#About Us"
                className="product-specification-thq-link-elm20"
              >
                About
              </a>
              <a
                href="#Why Us"
                className="product-specification-thq-link-elm21"
              >
                Why Us
              </a>
              <a
                href="#2 Featured Product"
                className="product-specification-thq-link-elm22"
              >
                Featured Product
              </a>
              <a
                href="#Contact"
                className="product-specification-thq-link-elm23"
              >
                Contact
              </a>
            </div>
          </div>
          <div className="product-specification-thq-list-elm2">
            <span className="product-specification-thq-header-elm2">
              Contact
            </span>
            <div className="product-specification-thq-links-elm3">
              <span className="product-specification-thq-link-elm24">
                Barangay Sta. Catalina Sur Candelaria, Quezon Province
              </span>
              <a
                href="mailto:contact@template.new?subject=Main"
                className="product-specification-thq-link-elm25"
              >
                HeidricIGT.ops@gmail.com
              </a>
              <a
                href="tel:(004) 234 - 5678"
                className="product-specification-thq-link-elm26"
              >
                +63 949 363 8688
              </a>
              <a
                href="tel:(004) 234 - 5678"
                className="product-specification-thq-link-elm27"
              >
                +63 919 998 8580
              </a>
            </div>
          </div>
        </div>
        <div className="product-specification-thq-legal-elm2">
          <div className="product-specification-thq-row-elm">
            <span className="legal-link">Privacy Policy</span>
            <span className="legal-link">Terms of Use</span>
          </div>
          <span className="product-specification-thq-copyright-elm4">
            © 2022 finbest. All Rights Reserved.
          </span>
        </div>
      </div>

    </div>
  )
}

export default ProductSpecification
